import { useEffect, useState } from "react";
import axios from "axios";

export default function QRList() {
  const [list, setList] = useState([]);

  useEffect(() => {
    axios.get("https://mdqapps.online/qrgen_api/api/get_qr.php")
      .then(res => setList(res.data));
  }, []);

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Saved QR Codes</h3>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Name</th>
            <th style={styles.th}>QR Code</th>
            <th style={styles.th}>Download</th>
          </tr>
        </thead>

        <tbody>
          {list.map(item => (
            <tr key={item.id} style={styles.tr}>
              <td style={styles.td}>{item.name}</td>

              <td style={styles.td}>
                <img
                  src={`https://mdqapps.online/qrgen_api/api/uploads/${item.qr_image}`}
                  width="80"
                  style={{ borderRadius: "6px" }}
                />
              </td>

              <td style={styles.td}>
                <a
                  href={`https://mdqapps.online/qrgen_api/api/${item.qr_image}`}
                  download
                  style={styles.downloadBtn}
                >
                  Download
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  container: {
    marginTop: "30px",
    padding: "20px",
    background: "#0f172a",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
  },
  title: {
    color: "#fff",
    marginBottom: "15px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#020617",
    borderRadius: "10px",
    overflow: "hidden",
  },
  th: {
    padding: "12px",
    textAlign: "left",
    background: "#1e3a8a",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #1e293b",
    color: "#e2e8f0",
    fontSize: "14px",
  },
  tr: {
    transition: "0.3s",
  },
  downloadBtn: {
    padding: "6px 12px",
    background: "#2563eb",
    color: "#fff",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "13px",
  },
};